<template>
  <v-sparkline
    style="height:48px;"
    :value="healthData"
    :gradient="healthColorsHex"
    gradient-direction="bottom"
    :smooth="true"
    :line-width="5"
    :padding="4"
    stroke-linecap="round"
    auto-draw
  />
</template>

<script>
import { healthColorsHex } from '@/config/projects'

export default {
  props: {
    health: {
      type: Array,
      default: () => [ 0, 0 ]
    }
  },
  data () {
    return {
      healthColorsHex
    }
  },
  computed: {
    healthData () {
      return [...this.health].reverse()
    }
  }
}
</script>
